<section class="about-section" id="aboutUs">
  <article class="about-hero">
    <div class="about-hero__inner">
      <div class="about-hero__content">
        <h1>
          {{ 'aboutUs.aboutPage.hero.titleLine1' | translate }}<br /><span>{{
            'aboutUs.aboutPage.hero.titleLine2' | translate
          }}</span>
        </h1>
        <p>
          {{ 'aboutUs.aboutPage.hero.description' | translate }}
        </p>
      </div>
      <div class="about-hero__media">
        <img
          src="assets/images/about-us/About-Us-Page.webp"
          [attr.alt]="'aboutUs.aboutPage.hero.imageAlt' | translate"
          loading="lazy" />
      </div>
    </div>
  </article>

  <article class="mission-section">
    <div class="mission-section__inner">
      <div class="mission-section__media">
        <img
          src="assets/images/about-us/fragmented-industry-unsplash-2.webp"
          [attr.alt]="'aboutUs.aboutPage.mission.imageAlt' | translate"
          loading="lazy" />
        <div class="mission-section__badge">
          <i class="iconsax" icon-name="document-text-1"></i>
          <p>
            {{ 'aboutUs.aboutPage.mission.badge' | translate }}
          </p>
        </div>
      </div>

      <div class="mission-section__content">
        <p class="mission-section__eyebrow">
          {{ 'aboutUs.aboutPage.mission.eyebrow' | translate }}
        </p>
        <h2>{{ 'aboutUs.aboutPage.mission.title' | translate }}</h2>
        <p>
          {{ 'aboutUs.aboutPage.mission.description1' | translate }}
        </p>
        <p>
          {{ 'aboutUs.aboutPage.mission.description2Prefix' | translate }}
          <strong>{{
            'aboutUs.aboutPage.mission.description2Highlight' | translate
          }}</strong>
          {{ 'aboutUs.aboutPage.mission.description2Suffix' | translate }}
        </p>

        <div class="mission-section__cards">
          <article class="mission-card">
            <i class="iconsax" icon-name="tick-circle"></i>
            <h3>{{ 'aboutUs.aboutPage.mission.cards.safety.title' | translate }}</h3>
            <p>
              {{ 'aboutUs.aboutPage.mission.cards.safety.description' | translate }}
            </p>
          </article>
          <article class="mission-card">
            <i class="iconsax" icon-name="box"></i>
            <h3>{{ 'aboutUs.aboutPage.mission.cards.escrow.title' | translate }}</h3>
            <p>
              {{ 'aboutUs.aboutPage.mission.cards.escrow.description' | translate }}
            </p>
          </article>
        </div>
      </div>
    </div>
  </article>

  <article class="ecosystem-section">
    <div class="ecosystem-section__inner">
      <p class="ecosystem-section__eyebrow">
        {{ 'aboutUs.aboutPage.ecosystem.eyebrow' | translate }}
      </p>
      <h2>{{ 'aboutUs.aboutPage.ecosystem.title' | translate }}</h2>
      <p class="ecosystem-section__intro">
        {{ 'aboutUs.aboutPage.ecosystem.intro' | translate }}
      </p>

      <div class="ecosystem-section__grid">
        <article class="audience-card">
          <i class="iconsax" icon-name="document-text-1"></i>
          <h3>{{ 'aboutUs.aboutPage.ecosystem.audiences.developers.title' | translate }}</h3>
          <p>
            {{ 'aboutUs.aboutPage.ecosystem.audiences.developers.description' | translate }}
          </p>
        </article>
        <article class="audience-card">
          <i class="iconsax" icon-name="user-1"></i>
          <h3>{{ 'aboutUs.aboutPage.ecosystem.audiences.contractors.title' | translate }}</h3>
          <p>
            {{ 'aboutUs.aboutPage.ecosystem.audiences.contractors.description' | translate }}
          </p>
        </article>
        <article class="audience-card">
          <i class="iconsax" icon-name="box"></i>
          <h3>{{ 'aboutUs.aboutPage.ecosystem.audiences.suppliers.title' | translate }}</h3>
          <p>
            {{ 'aboutUs.aboutPage.ecosystem.audiences.suppliers.description' | translate }}
          </p>
        </article>
        <article class="audience-card">
          <i class="iconsax" icon-name="login"></i>
          <h3>{{ 'aboutUs.aboutPage.ecosystem.audiences.homeowners.title' | translate }}</h3>
          <p>
            {{ 'aboutUs.aboutPage.ecosystem.audiences.homeowners.description' | translate }}
          </p>
        </article>
      </div>
    </div>
  </article>
</section>
